/* eslint-disable @angular-eslint/component-class-suffix */
import { Component } from '@angular/core';

import { AuthFacade } from '../../+state/auth.facade';

/**
 * Login component
 */
@Component({
  standalone: false,
  templateUrl: './forbidden.container.html',
  styleUrls: ['./forbidden.container.scss'],
})
export class ForbiddenContainer {
  constructor(private facade: AuthFacade) {}

  error$ = this.facade.error$;

  logout() {
    this.facade.logout();
  }
}
